import { Button } from '@shared/components/ui/button';
import { EmptyView, EMPTY_VIEW_ICONS } from '@shared/components/ui/EmptyView';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreatePackButton } from '../interaction';
import { PacksGridSkeleton } from '../skeletons';

interface PacksStatesProps {
  isLoading: boolean;
  error: unknown;
  packsCount: number;
  searchTerm: string;
  onRefetch: () => void;
  onCreatePack: () => void;
}

const PacksStates: React.FC<PacksStatesProps> = ({
  isLoading,
  error,
  packsCount,
  searchTerm,
  onRefetch,
  onCreatePack,
}) => {
  const { t } = useTranslation('packsModule');

  // 🔄 Estado de carga inicial - Skeleton de los bloques
  if (isLoading && packsCount === 0) {
    return <PacksGridSkeleton />;
  }

  // ❌ Estado de error
  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-destructive mb-4">{t('errors.network')}</p>
        <Button onClick={onRefetch} variant="outline" size="sm" data-testid="refetch-button">
          {t('button.loading')}
        </Button>
      </div>
    );
  }

  // 📭 Estado vacío
  if (!isLoading && !error && packsCount === 0) {
    return (
      <EmptyView
        type={searchTerm ? 'noResults' : 'emptyState'}
        icon={EMPTY_VIEW_ICONS.ORDER_PREPARATION} // Icono de estantes apilados (perfecto para packs)
        customAction={searchTerm ? null : <CreatePackButton onCreatePack={onCreatePack} />}
      />
    );
  }

  return null;
};

export default PacksStates;
